import PropTypes from 'prop-types';
import LinkedFiles from './LinkedFiles';
import { FormattedMessage } from 'react-intl';

export const SupplementalLinkedFile = ({ linkedFiles, assetType, assetTypeId }) => {
    return (linkedFiles && linkedFiles.length > 0 &&
        <>
            <div className="govuk-caption-m">
                <FormattedMessage id='supplementaryDataTab.externalResources'/>
            </div>
            <LinkedFiles
                linkedFiles={linkedFiles}
                assetType={assetType}
                assetTypeId={assetTypeId}>
            </LinkedFiles>
            <hr className="govuk-section-break govuk-section-break--m govuk-section-break--visible"/>
        </>

    );
};

SupplementalLinkedFile.propTypes = {
    linkedFiles: PropTypes.array,
    assetType: PropTypes.string.isRequired,
    assetTypeId: PropTypes.string.isRequired
};
